import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Edit License", -1)
const _hoisted_3 = { class: "grid p-fluid align-items-center" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Title", -1)
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "field-checkbox" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "selectable" }, "Can be subscribed to", -1)
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1)
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Price (USD)", -1)
const _hoisted_14 = { class: "p-inputgroup" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-dollar" })
], -1)
const _hoisted_16 = { class: "grid p-fluid align-items-center" }
const _hoisted_17 = { class: "col-8" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Duration", -1)
const _hoisted_20 = { class: "p-inputgroup" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Days", -1)
const _hoisted_22 = { class: "col-4" }
const _hoisted_23 = { class: "field-checkbox" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "singleUse" }, "Single Use", -1)
const _hoisted_25 = { class: "field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Maximum Concurrent Users", -1)
const _hoisted_27 = { class: "form-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.license)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputText, {
                  id: "title",
                  type: "text",
                  modelValue: _ctx.license.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.license.title) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Checkbox, {
                  id: "selectable",
                  name: "selectable",
                  modelValue: _ctx.license.selectable,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.license.selectable) = $event)),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _hoisted_9
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Textarea, {
              id: "description",
              modelValue: _ctx.license.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.license.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_InputText, {
                id: "title",
                type: "number",
                max: "9000",
                step: "10",
                modelValue: _ctx.license.price,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.license.price) = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_InputText, {
                    id: "title",
                    type: "number",
                    modelValue: _ctx.license.duration,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.license.duration) = $event)),
                    modelModifiers: { number: true }
                  }, null, 8, ["modelValue"]),
                  _hoisted_21
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_Checkbox, {
                  id: "singleUse",
                  name: "singleUse",
                  modelValue: _ctx.license.singleUse,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.license.singleUse) = $event)),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _hoisted_24
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_InputText, {
              id: "title",
              type: "number",
              max: "20",
              modelValue: _ctx.license.maxConcurrentUsers,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.license.maxConcurrentUsers) = $event)),
              modelModifiers: { number: true }
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Button, {
              label: "Submit",
              type: "submit"
            })
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}